import {queryApiUrl} from '../utils';
import {BaseClient} from '../utils/base-client';

class CustomPropertiesValidateClient extends BaseClient {
  buildEndpoint() {
    return queryApiUrl(`custom_properties/substitute_variables`);
  }

  buildQueryParams(params) {
    /* eslint-disable camelcase */
    return {
      project_id: params.projectId,
    };
    /* eslint-enable camelcase */
  }

  buildRequestBody(params) {
    /* eslint-disable camelcase */
    return JSON.stringify({
      selector: params.selector,
      variable_substitutions: JSON.stringify(params.variableSubstitutions),
    });
    /* eslint-enable camelcase */
  }

  processResponse(response, _) {
    return response;
  }
}

export const customPropertiesValidateClient = new CustomPropertiesValidateClient();
